import { useSelector } from 'react-redux';
import { AppState } from 'modules/redux-store';

export const useCheckIfImpersonate = () => {
  const { user } = useSelector((state: AppState) => state.adminImpersonate);

  return !!user?.adminId;
};
